import React from 'react';
import LogItemCard from './LogItemCard'
import { MuiGrid, MuiTypography, MuiIconButton, MuiCancel } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import '../../../ui/scrollbarForLog.css'

function LogListComponent(props) {
    let errorCount = props.log.errorsCount
    let warningsCount = props.log.warningsCount
    const { i18n } = props
    return (
        <MuiGrid container xs={12} >
            <MuiGrid container xs={12} style={{ padding: 12 }}>
                <MuiGrid xs >  <MuiTypography variant={theme.typographyStyles.H6} align='left' style={{ color: theme.palette.primary.dark, fontWeight: 700 }}>
                    {errorCount > 0 && errorCount != undefined ? i18n.log.errorLogTitle : i18n.log.timeTableLogTitle}</MuiTypography>
                    <MuiTypography variant={theme.typographyStyles.BODY} align='left' style={{ color: theme.palette.primary.dark, fontWeight: 700 }}>
                        [{errorCount > 0 ? i18n.log.errors + ' :' + errorCount : ''}
                        {warningsCount > 0 && errorCount > 0 ? ' ,' : ""}
                        {warningsCount > 0 ? i18n.log.warnings + ' :' + + warningsCount : ''}]</MuiTypography>
                </MuiGrid>
                <MuiGrid> <MuiIconButton onClick={() => props.viewErrors(props.displayError)}><MuiCancel style={{ color: theme.palette.primary.dark }} /></MuiIconButton></MuiGrid>



            </MuiGrid>
            <MuiGrid style={{ height: '80vh', overflowY: 'scroll', width: '100%', wordBreak: 'break-word' }} id='scrollStyle' direction="column" alignItems='space-between' align='left' spacing={2}>
                {props.log.errors.map((errorItem, index) =>
                    <MuiGrid key={index} item style={{
                        width: '100%',
                        border: props.errorItemIndex == index ? '1px solid red' : "none",

                    }} alignItems="flex-start" id="grid" >
                        <LogItemCard index={index} {...props} logItem={errorItem}
                        />
                    </MuiGrid>
                )}
            </MuiGrid >
        </MuiGrid>
    )

}



export default LogListComponent;